import { connect } from 'react-redux'
import get from 'lodash/get';

import {
  chooseCar as onChooseCar,
  clearChoosedCar as onClearChoosedCar,
} from '../../actions/choosedCarActions'

const mapStateToProps = (state) => ({
  choosedCarId: get(state, ['choosedCar', 'data', 'id'], null),
  choosedCarNumber: get(state, ['choosedCar', 'data', 'number'], ''),
});

const mapDispatchToProps = {
  onChooseCar,
  onClearChoosedCar,
}

const withChoosedCar = Component => connect(mapStateToProps, mapDispatchToProps)(Component)

export { withChoosedCar }